import { sdkContextStatus } from "src/context/SDKContext"
import { useQuery } from "react-query"
import axios from "src/shared/axios"

const QUERY_KEY = "inspiration-categories"

export type InspirationCategoryModel = {
  id: number
  name: string
  position: number
}

export function useInspirationCategories() {
  const { data } = useQuery({
    queryKey: [QUERY_KEY],
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    queryFn: async () => {
      console.trace("useQuery")
      const meetingClient = await sdkContextStatus
      const url = new URL(meetingClient?.envConfig.INSPIRATION_CATEGORIES_URL)
      url.searchParams.append("host", meetingClient?.envConfig.DOMAIN_HOSTNAME)
      try {
        const response = await axios.get(url.toString())
        return response.data
      } catch (err) {
        console.error(err)
        throw err
      }
    }
  })
  const categories: InspirationCategoryModel[] =
    data?.inspiration_categories?.sort((a, b) => a.position - b.position)
  return { categories }
}
